<template>
  <label class="checkbox-wrapper">
    <span class="checkbox-inner">
      <input
        type="checkbox"
        class="checkbox__input"
        :checked="value"
        @change="onChange"
      >
      <span class="checkbox__custom">
        <transition name="drop">
          <Checkmark
            v-if="value"
            class="checkbox__custom-checkmark"
          />
        </transition>
      </span>

      <span class="checkbox__text">
        <slot />
      </span>

    </span>

    <transition name="slide-from-top">
      <span
        v-if="error && errorMsg"
        class="checkbox__error-msg"
      >
        {{ errorMsg }}
      </span>
    </transition>
  </label>
</template>

<script>
  import Checkmark from '@/assets/img/icons/checkmark.svg?inline'

  export default {
    name: 'BaseCheckbox',
    components: {
      Checkmark
    },
    props: {
      typeNumber: Boolean,
      value: [Boolean, Number],
      errorMsg: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        error: null
      }
    },
    watch: {
      errorMsg: {
        handler (msg) {
          this.error = !!msg
        },
        immediate: true
      }
    },
    methods: {
      onChange (e) {
        this.error = false

        const newValue = this.typeNumber
          ? Number(e.target.checked)
          : e.target.checked

        this.$emit('input', newValue)
        this.$emit('change', newValue)
      }
    }

  }
</script>

<style lang="scss">
  $padding-for-error: 16px;

  .checkbox {
    display: inline-block;
    flex-shrink: 0;
    flex-grow: 0;

    &-inner {
      display: flex;
      align-items: center;
    }

    &-wrapper {
      margin-top: 16px;
      display: flex;
      position: relative;
      padding-bottom: $padding-for-error;
      &:hover {
        .checkbox__custom {
          background: $c-silver;
          border-color: $c-gray-medium;
        }
      }
    }

    &__custom {
      width: 20px;
      height: 20px;
      cursor: pointer;
      border: 1px solid $c-gray-new;
      transition: 0.3s;
      display: flex;
      flex-shrink: 0;
      flex-grow: 0;
      align-items: center;
      justify-content: center;
      &:hover{

        .checkbox__custom{
          background: $c-silver;
        }
      }

      &-checkmark {
        fill: $c-active-light;
      }
    }

    &__input {
      position: absolute;
      left: -9999999px;
      width: 0;
      height: 0;
      opacity: 0;

      &:focus {
        & + .checkbox__custom {
          border-color: $c-gray-medium;
        }
      }

      &:checked {
        +.checkbox__custom{
          border: 1px solid $c-black-primary;
          background: $c-black-primary;
        }
      }
    }

    &__text {
      font-family: 'NobelWGL-Book';
      margin-left: 8px;
      font-size: 16px;
      font-weight: 400;
      letter-spacing: 0.14px;
      a{
        font-family: 'NobelWGL-Book';
        font-size: 16px;
        letter-spacing: 0.14px;
        font-weight: 400;
      }
    }

    &__error-msg {
      position: absolute;
      bottom: 23px;
      left: 0;
      height: 0;
      font-size: 12px;
      color: $c-active-light;
    }
  }
</style>
